// Reconstructed from the supplied production build; original component names were unavailable.
const PasswordResetSuccess = ({ onBackToLogin: a }) => (
  <div
    className={
      "bg-white rounded-2xl lg:rounded-3xl shadow-2xl p-4 lg:p-10 w-full max-w-sm lg:max-w-md mx-auto animate-fadeInUp"
    }
  >
    <div className={"text-center"}>
      <div
        className={
          "mx-auto w-16 h-16 lg:w-20 lg:h-20 bg-green-100 rounded-full flex items-center justify-center mb-6 animate-checkmark"
        }
      >
        <svg
          className={"w-8 h-8 lg:w-10 lg:h-10 text-green-600"}
          fill={"none"}
          stroke={"currentColor"}
          viewBox={"0 0 24 24"}
        >
          <path
            strokeLinecap={"round"}
            strokeLinejoin={"round"}
            strokeWidth={"3"}
            d={"M5 13l4 4L19 7"}
          />
        </svg>
      </div>
      <h2 className={"text-lg lg:text-2xl font-bold text-gray-800 mb-3"}>
        {"Password Reset Successful!"}
      </h2>
      <p className={"text-gray-600 text-xs lg:text-base mb-6 leading-relaxed"}>
        {"Your password has been successfully reset. You can now log in with your new password."}
      </p>
      <button
        onClick={a}
        className={
          "w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-2.5 lg:py-4 px-4 lg:px-6 rounded-lg lg:rounded-xl text-xs lg:text-base transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none shadow-lg hover:shadow-xl"
        }
      >
        {"Back to Login"}
      </button>
    </div>
  </div>
);
export { PasswordResetSuccess };
